import { CommonModule, isPlatformBrowser } from "@angular/common";
import { Component, Inject, } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA,  MatDialog,  MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
//import { RECAPTCHA_V3_SITE_KEY, ReCaptchaV3Service, RecaptchaLoaderService, RecaptchaV3Module } from "ng-recaptcha";
//import { IOauthResponse } from "src/app/api/oauth/response/i-oauth.request";
import { LoginService } from "../../../data/model/login-model/login.service";
import { ShowBasicAlert } from "../../../helpers/global_functions";
import { environment } from "../../../../environments/environment";
import { EncryptUtil } from "../../../providers/encrypt.provider.rsa";
import { IconModule } from "../../../shared/icon/icon.module";
import { LoginRequest } from "../../../data/model/login-model/request/login-request";
import { v4 as uuidv4 } from 'uuid';
import { StrictHttpResponse } from "../../../data/model/generic/strict-http.response";
import { LoginResponse } from "../../../data/model/login-model/response/login-response";
import { PLATFORM_ID } from '@angular/core';
import { MainContentClass } from "../../../helpers/main-content.service.class";
import { ApiService } from "../../../helpers/api.service";
import { Meta, Title } from "@angular/platform-browser";

@Component({
  selector: 'login-modal',
  templateUrl: 'login-modal.html',
  standalone: true,
  imports: [CommonModule,  MatDialogContent, MatDialogActions, MatDialogClose, FormsModule, ReactiveFormsModule, IconModule],
//   providers: [
//     { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchav3 },
//     ReCaptchaV3Service,
//   ],
  styles: [`
    .custom-dialog-content {
      max-height: 400px;
      width: 400px;
      overflow-y: auto;
    }
  `]
})
export class LoginModal extends MainContentClass {

  modalForm!: FormGroup;
  loading: boolean = false;
  failPassword: string = "";
  reCaptchaScript: HTMLScriptElement | undefined;
  isPasswordVisible: boolean = false;
  private channelService: BroadcastChannel;

  constructor(
    router: Router, 
    route: ActivatedRoute, 
    genericService: ApiService, 
    public fb: FormBuilder,
    @Inject(PLATFORM_ID) platformId: Object,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    public dialogRef: MatDialogRef<LoginModal>,
    private loginService: LoginService,
    private dialog: MatDialog
  ) {
    super(router, route,genericService,dialog, platformId);
    this.channelService = new BroadcastChannel('session_channel');
    this.modalForm = this.fb.group({
        user: ['', [Validators.required]],//leninlarryvillanera@gmail.com
        password: ['', [Validators.required]],
    });
    // const elementBad = document.body.querySelector(".grecaptcha-badge");
    // if (elementBad) {
    //   elementBad.parentElement?.remove();
    // }
  }

  ngOnInit(): void {
    //this.loadRecaptchaScript();
  }

  // public fieldValidated(formG: FormGroup, field: string) {
  //   return formG.controls[field].errors && formG.controls[field].touched;
  // }


  get f(): { [key: string]: AbstractControl } {
    return this.modalForm.controls;
  }


//   loadRecaptchaScript() {
//     this.reCaptchaScript = document.createElement('script');
//     this.reCaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=${environment.recaptchav3}`;
//     this.reCaptchaScript.async = true;
//     this.reCaptchaScript.defer = true;
//     document.body.appendChild(this.reCaptchaScript);
//   }


  saveLogin()  {
    this.login();
  }

//   getToken = async () => {
//     return new Promise<string>((resolve, reject) => {
//       this.recaptcha.execute('loginAction')
//         .subscribe((token: string) => {
//           resolve(token);
//         });
//     });
//   }

  // logout() {
  //   this.router.navigate(['admin/ofpagesession']);
  // }

  protected async login() {
    if (this.modalForm.invalid) {
      this.modalForm.markAllAsTouched();
      ShowBasicAlert({
        customClass: 'sweet-alerts',
        title: 'Oops verifique el mensaje',
        text: 'Complete los campos solicitados',
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#552DE4',
      }).then((result) => {
      }).catch((err) => {
      });
      return;
    }
    localStorage.clear();
    this.showLoader();
    this.loading = true;

    var generateSaltIv = EncryptUtil.generateSaltAndIv();

    var num1: number = (Math.floor(Math.random() * 9) + 1) + 1;
    var num2: number = (Math.floor(Math.random() * 9) + 1) + 1;
    var mathNum1: number = (Math.floor(Math.random() * 9) + 1) + 1;
    var mathNum2: number = (Math.floor(Math.random() * 9) + 1) + 1;

    var saltnum1: number = (Math.floor(Math.random() * 9) + 1) + 1;
    var saltnum2: number = (Math.floor(Math.random() * 9) + 1) + 1;
    var saltmathNum1: number = (Math.floor(Math.random() * 9) + 1) + 1;
    var saltmathNum2: number = (Math.floor(Math.random() * 9) + 1) + 1;

    var uname = EncryptUtil.encryptAES(this.modalForm.get("user")?.value, environment.secretKey,generateSaltIv.iv,generateSaltIv.salt);
    var password = EncryptUtil.encryptAES(this.modalForm.get("password")?.value, environment.secretKey,generateSaltIv.iv,generateSaltIv.salt).ciphertext;
    var isGoogle = EncryptUtil.encryptAES("3", environment.secretKey,generateSaltIv.iv,generateSaltIv.salt).ciphertext;
    const browserId = this.getOrCreateBrowserId(uname.ciphertext);
    var uniqueIdWeb = EncryptUtil.encryptAES(browserId, environment.secretKey,generateSaltIv.iv,generateSaltIv.salt).ciphertext;
    var hashdata = EncryptUtil.encryptRSA((mathNum2 * 2 + num1 + 0 + mathNum1 + mathNum1 + num2 + num2 + mathNum2).toString());
    var hashmac = EncryptUtil.encryptRSA((saltmathNum2 * 2 + saltnum1)+(saltmathNum1+saltmathNum1)+saltnum2+""+saltnum2+saltmathNum2);

    var headerToken = (num1 + mathNum1)+(num1 + mathNum1 + mathNum2)+(num2 + mathNum2);
    var saltheaderToken = (saltnum1 + saltmathNum1)+(saltnum1 + saltmathNum1 + saltmathNum2)+(saltnum2 + saltmathNum2);

    var bodyRequest: LoginRequest = {
      mathNum2: mathNum2,
      mathNum1: mathNum1,
      num2: num2,
      num1: num1,
      modeldevice: uname.ciphertext,
      uniqUui: uniqueIdWeb,
      password: password,
      isGoogle: isGoogle,
      username: uname.ciphertext
    };

    this.loginService.postLoginResponse(bodyRequest, {
      "Content-Type": "application/json",
      "x-sap": EncryptUtil.encryptRSA(generateSaltIv.iv),
      "x-evp": EncryptUtil.encryptRSA(generateSaltIv.salt),
      "x-token": headerToken.toString(),
      "x-accesstoken": EncryptUtil.encryptRSA(num1+""+generateSaltIv.iv+""+mathNum2),
      "x-tokendevice": EncryptUtil.encryptRSA(saltheaderToken.toString()),
      "x-accesstokenmac": EncryptUtil.encryptRSA(saltnum1+""+saltmathNum2),
      "x-hashdata": hashdata,
      "x-hashdatamac": hashmac,
    })
      .subscribe({
        next: (success: StrictHttpResponse<LoginResponse>) => {
          this.loading = false;
          this.hideLoader();
          //this.channelService.postMessage({ type: 'USER_LOGGED' });
          if(success.body.status == 200) {
            localStorage.setItem(environment.constants.mailinfo,EncryptUtil.encryptAES(success.body.data.email,environment.secretKeyApp,"52015cf6259abf91c1db166587d67cd2","db4ace4d7223d0cce78f5f36376cafd5").ciphertext)
            localStorage.setItem(environment.constants.uid,EncryptUtil.encryptAES(success.body.data.id.toString(),environment.secretKeyApp,"52015cf6259abf91c1db166587d67cd2","db4ace4d7223d0cce78f5f36376cafd5").ciphertext)
            this.closeDialog();
            this.validationStatusResponse(success.body, () => {
              this.router.navigate(['admin/home']);
            });
          } else {
            const info : any = success.body;
            ShowBasicAlert({
              text: info.message,
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#552DE4',
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then((result) => {
              if(result.isConfirmed) {
                this.logout();
              }
            });
          }
        }, error: (e: any) => {
          this.loading = false;
          this.hideLoader();

          ShowBasicAlert({
            customClass: 'sweet-alerts',
            title: 'Información',
            text: 'Usuario y/o contraseña incorrecta, por favor vuelve a intentarlo',
            //icon: 'warning',
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#552DE4',
          }).then((result) => {
          }).catch((err) => {
          });

        }

      });

  }


  closeDialog(): void {
    this.dialogRef.close();
  }

}